import { useState } from 'react';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Collapse,
    NavItem,
    NavLink,
} from 'shards-react';
import { connect } from 'react-redux';
import questionLogo from '../../../../assets/images/synop_frage.png';

const UserActions = ({ trainingMaterialsToShow }) => {
    /**
     * Later we'll take user name from DB!
     * Define default avatar or take it from DB!?!
     */
    const [visible, setVisible] = useState(false);

    const toggleHelpActions = () => setVisible(!visible);

    return (
        <NavItem
            className='border-left pointer'
            tag={Dropdown}
            toggle={toggleHelpActions}
        >
            <DropdownToggle tag={NavLink} className='px-3'>
                <img className='rounded-circle mr-3 question-synop' src={questionLogo}/>
            </DropdownToggle>
            <Collapse tag={DropdownMenu} right small open={visible}>
                {trainingMaterialsToShow?.length > 0 &&
                    trainingMaterialsToShow.map((it) => (
                        <DropdownItem
                            key={it._id}
                            className='text-secondary'
                            tag='a'
                            href={it.link}
                            target='_blank'
                        >
                            {it.title}
                        </DropdownItem>
                    ))}
            </Collapse>
        </NavItem>
    );
};

const mapStateToProps = ({ userData: { services, trainingMaterials } }) => {
    const serviceTypeList = services.map(({ serviceType }) => serviceType);
    const trainingMaterialsToShow = trainingMaterials?.filter(
        (it) =>
            it.target_service_type === undefined ||
            (it.target_service_type &&
                serviceTypeList.includes(it.target_service_type))
    );

    return {
        trainingMaterialsToShow,
    };
};
export default connect(mapStateToProps)(UserActions); //Export component and connect it with redux.
